var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statisticBottle"},[_vm._t("default"),_c('div',{staticClass:"statisticBottle-overlay",style:({ height: (_vm.percentage + "%") })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }